import { render, staticRenderFns } from "./DashboardFolderOptionsMenu.vue?vue&type=template&id=482d7c72"
import script from "./DashboardFolderOptionsMenu.vue?vue&type=script&lang=js"
export * from "./DashboardFolderOptionsMenu.vue?vue&type=script&lang=js"
import style0 from "./DashboardFolderOptionsMenu.vue?vue&type=style&index=0&id=482d7c72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports